import React, { useState, useEffect } from 'react';
import axios from '../api/api'
import { FaUsers, FaUser, FaUserFriends, FaUserPlus } from "react-icons/fa";
import { LineChart, Line, BarChart, Bar, XAxis, YAxis, Tooltip, Legend, CartesianGrid, ComposedChart, ResponsiveContainer } from 'recharts';
import SkeletonLoader from './SkeletonLoader'
import GraphSkeletonLoader from './GraphSkeletonLoader'

const Home = () => {

  const [stats, setStats] = useState([])
  const [c2bconfirmation, setC2bconfirmation] = useState([])
  const [logarchive, setLogarchive] = useState([])
  const [total, setTotal] = useState(0)
  const [loading, setLoading] = useState(true);

  const CurrentYear = new Date().getFullYear();
  const CurrentMonth = new Date().getMonth() + 1; 

  const lastDayOfMonth = new Date(CurrentYear, CurrentMonth, 0).getDate();
  const yearStr = CurrentYear.toString();
  const monthStr = CurrentMonth.toString().padStart(2, '0');


  const startDate = `${yearStr}-${monthStr}-01`;
  const endDate = `${yearStr}-${monthStr}-${lastDayOfMonth.toString().padStart(2, '0')}`;
  const startMonth = `${yearStr}-01-01`;
  const endMonth = `${yearStr}-12-${lastDayOfMonth.toString().padStart(2, '0')}`;


  const [dayStats, setDayStats] = useState([]);
  const [monthStats, setMonthStats] = useState([]);
  const [startDateFilter, setStartDateFilter] = useState(startDate);
  const [endDateFilter, setEndDateFilter] = useState(endDate);

  const handleStartDateChange = (e) => {
    setStartDateFilter(e.target.value);
  };

  const handleEndDateChange = (e) => {
    setEndDateFilter(e.target.value);
  };
  
  // useEffect(() => {
  //   const getStats = async () => {
  //     try {
  //       const response = await axios.get('/stats/')
  //       setStats(response.data.items[0])
  //       setTotal(response.data.total)
  //     } catch (error) {
  //       console.log(error)
  //     } finally {
  //       setLoading(false)
  //     }
  //   }
  //   getStats()
  // }, [])

  // // day
  // useEffect(() => {
  //   const fetchDayData = async () => {
  //     try {
  //       const response = await axios.get(`stats/graph-stats?group_by=day&start_date=${startDateFilter}&end_date=${endDateFilter}`);
  //       setDayStats(response.data.items);
  //     } catch (error) {
  //       console.error(error);
  //     } finally {
  //       setLoading(false)
  //     }
  //   };
  //   fetchDayData();
  // }, [startDateFilter, endDateFilter]);

  // // month
  // useEffect(() => {
  //   const fetchMonthData = async () => {
  //     try {
  //       const response = await axios.get(`stats/graph-stats?group_by=month&start_date=${startMonth}&end_date=${endMonth}`);
  //       setMonthStats(response.data.items);
  //     } catch (error) {
  //       console.error(error);
  //     } finally {
  //       setLoading(false)
  //     }
  //   };
  //   fetchMonthData();
  // }, [startMonth,endMonth]);

  // useEffect(() => {
  //   const getC2bStats = async () => {
  //     try {
  //       const response = await axios.get('/stats/c2b_confirmation')
  //       setC2bconfirmation(response.data.items)
  //     } catch (error) {
  //       console.log(error)
  //     } finally {
  //       setLoading(false)
  //     }
  //   }
  //   getC2bStats()
  // }, [])

  // useEffect(() => {
  //   const getLogarchiveStats = async () => {
  //     try {
  //       const response = await axios.get('/stats/log_archive')
  //       setLogarchive(response.data.items)
  //     } catch (error) {
  //       console.log(error)
  //     } finally {
  //       setLoading(false)
  //     }
  //   }
  //   getLogarchiveStats()
  // }, [])

  // user details
  const currentUser = window.localStorage.getItem('token');
  const user = JSON.parse(currentUser).data.user_data;

  return (
    <main className='mx-auto p-4'>
      {/* {(user.role === 'SYSTEM_ADMIN' || user.role === 'FINANCE') ? (
        <div>
          <section className="flex flex-wrap items-center justify-between gap-2">
            <h3><b>Admin DashBoard</b></h3>
            <form className='flex gap-2 w-full md:w-1/2 xl:w-1/3'>
              <div className='w-full'>
                <label htmlFor='startdate'>From Date
                  <input
                    type='date'
                    required
                    className='px-3 py-1.5 bg-inherit border-2 shadow-sm border-[#134463] placeholder-slate-400 focus:outline-none focus:border-[#134463] focus:ring-[#134463] block w-full rounded-md sm:text-sm focus:ring-1'
                    value={startDateFilter}
                    onChange={handleStartDateChange}
                  />
                </label>
              </div>
              <div className='w-full'>
                <label htmlFor='enddate'>To Date
                  <input
                    type='date'
                    required
                    className='px-3 py-1.5 bg-inherit border-2 shadow-sm border-[#134463] placeholder-slate-400 focus:outline-none focus:border-[#134463] focus:ring-[#134463] block w-full rounded-md sm:text-sm focus:ring-1'
                    value={endDateFilter}
                    onChange={handleEndDateChange}
                  />
                </label>
              </div>
            </form>
          </section>
          {loading || !stats ? (
            <SkeletonLoader/>
          ) : (
            <section className="grid grid-cols-1 gap-4 lg:grid-cols-4 my-4">
              <div className="bg-white p-4 lg:p-2 xl:p-3 2xl:p-4 rounded-lg">
                <div className='flex items-center space-x-4'>
                  <div className='text-4xl p-4 lg:text-xl xl:text-2xl 2xl:text-4xl bg-purple-700 text-white lg:p-2 xl:p-3 2xl:p-4 rounded-md'>
                    <span >
                      <FaUsers />
                    </span>
                  </div>
                  <div>
                    <h4 className='text-lg lg:text-[14px] xl:text-[16px] 2xl:text-lg'><b>Customers: </b></h4>
                    <h4 className='text-purple-700 font-bold'>{total ? total.toLocaleString() : 0}</h4>
                  </div>
                </div>
              </div>
              <div className="bg-white p-4 lg:p-2 xl:p-3 2xl:p-4 rounded-lg">
                <div className='flex items-center space-x-4'>
                  <div className='text-4xl p-4 lg:text-xl xl:text-2xl 2xl:text-4xl bg-blue-700 text-white lg:p-2 xl:p-3 2xl:p-4 rounded-md'>
                    <span >
                      <FaUser />
                    </span>
                  </div>
                  <div>
                    <h4 className='text-lg lg:text-[14px] xl:text-[16px] 2xl:text-lg'><b>Total Customers: </b></h4>
                    <h4 className='text-blue-700 font-bold'>{stats.customers ? stats.customers.toLocaleString() : 0}</h4>
                  </div>
                </div>
              </div>
              <div className="bg-white p-4 lg:p-2 xl:p-3 2xl:p-4 rounded-lg">
                <div className='flex items-center space-x-4'>
                  <div className='text-4xl p-4 lg:text-xl xl:text-2xl 2xl:text-4xl bg-orange-700 text-white lg:p-2 xl:p-3 2xl:p-4 rounded-md'>
                    <span >
                      <FaUserFriends />
                    </span>
                  </div>
                  <div>
                    <h4 className='text-lg lg:text-[14px] xl:text-[16px] 2xl:text-lg'><b>Total Agents: </b></h4>
                    <h4 className='text-orange-700 font-bold'>{stats.agents ? stats.agents.toLocaleString() : 0}</h4>
                  </div>
                </div>
              </div>
              <div className="bg-white p-4 lg:p-2 xl:p-3 2xl:p-4 rounded-lg">
                <div className='flex items-center space-x-4'>
                  <div className='text-4xl p-4 lg:text-xl xl:text-2xl 2xl:text-4xl bg-green-700 text-white lg:p-2 xl:p-3 2xl:p-4 rounded-md'>
                    <span >
                      <FaUserPlus />
                    </span>
                  </div>
                  <div>
                    <h4 className='text-lg lg:text-[14px] xl:text-[16px] 2xl:text-lg'><b>Total Dealers: </b></h4>
                    <h4 className='text-green-700 font-bold'>{stats.dealers ? stats.dealers.toLocaleString() : 0}</h4>
                  </div>
                </div>
              </div>
            </section>
          )}
          <section className='grid grid-cols-1 gap-4 lg:grid-cols-2'>
            {loading || !dayStats ? (
              <GraphSkeletonLoader/>
            ) : (
              <div className='bg-white p-4 rounded-md' >
                <span><u><b>New Customers Per Day</b></u></span>
                <ResponsiveContainer width="100%" height={400}>
                  <LineChart data={dayStats}>
                    <CartesianGrid strokeDasharray="3 3" />
                    <XAxis dataKey="day" />
                    <YAxis tickFormatter={(value) => value.toLocaleString()} />
                    <Tooltip formatter={(value) => value.toLocaleString()} />
                    <Legend />
                    <Line type="monotone" dataKey="total_customers" stroke="#8884d8" />
                  </LineChart>
                </ResponsiveContainer>
              </div>
            )}
            {loading || !monthStats ? (
              <GraphSkeletonLoader/>
            ) : (
              <div className='bg-white p-4 rounded-md' >
                <span><u><b>New Customers Per Month</b></u></span>
                <ResponsiveContainer width="100%" height={400}>
                  <BarChart width={730} height={250} data={monthStats}>
                    <XAxis dataKey="day" />
                    <YAxis />
                    <Tooltip formatter={(value) => value.toLocaleString()}/>
                    <Legend />
                    <Bar dataKey="total_customers" fill="#8884d8" />
                  </BarChart>
                </ResponsiveContainer>
              </div>
            )}
            {loading || !c2bconfirmation ? (
              <GraphSkeletonLoader/>
            ) : (
              <div className='bg-white p-4 rounded-md' >
                <span><u><b>Mpesa confirmation</b></u></span>
                <ResponsiveContainer width="100%" height={400}>
                  <LineChart data={c2bconfirmation}>
                    <CartesianGrid strokeDasharray="3 3" />
                    <XAxis dataKey="shortcode" />
                    <YAxis />
                    <Tooltip formatter={(value) => value.toLocaleString()} />
                    <Legend />
                    <Line type="monotone" dataKey="total_amount" stroke="#8884d8" />
                  </LineChart>
                </ResponsiveContainer>
              </div>
            )}
            {loading || !logarchive ? (
              <GraphSkeletonLoader/>
            ) : (
              <div className='bg-white p-4 rounded-md' >
                <span><u><b>Daily Request Log Archive</b></u></span>
                <ResponsiveContainer width="100%" height={400}>
                  <ComposedChart width={730} height={250} data={logarchive}>
                    <XAxis dataKey="provider" />
                    <YAxis/>
                    <Tooltip formatter={(value) => value.toLocaleString()}/>
                    <Legend />
                    <CartesianGrid stroke="#f5f5f5" />
                    <Bar dataKey="total_amount" barSize={20} fill="#413ea0" />
                    <Line type="monotone" dataKey="total_bonus" stroke="#ff7300" />
                  </ComposedChart>
                </ResponsiveContainer>
              </div>
            )}
          </section>
        </div>
      ) : (
        <div className='bg-[#134463] text-white p-4 rounded-lg'>
          <h3><b>Welcome to our DashBoard</b></h3>
          <p>To get started use the links on your left.</p>
        </div>
      )} */}
      <div className='bg-[#134463] text-white p-4 rounded-lg'>
          <h3><b>Welcome to our DashBoard</b></h3>
          <p>To get started use the links on your left.</p>
        </div>
    </main>
  );
};

export default Home;
